import { createContext, useContext, useEffect, useState } from "react";
import { T } from "@/i18n";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("mero_lang") || "ar");

  useEffect(() => {
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
    localStorage.setItem("mero_lang", lang);
  }, [lang]);

  const t = (key) => T[lang]?.[key] ?? T.ar[key] ?? key;
  const pick = (ar, en) => (lang === "ar" ? (ar ?? en) : (en ?? ar));

  return (
    <LanguageContext.Provider
      value={{ lang, isRtl: lang === "ar", setLang, toggle: () => setLang((l) => (l === "ar" ? "en" : "ar")), t, pick }}
    >
      {children}
    </LanguageContext.Provider>
  );
}

export const useLang = () => useContext(LanguageContext);
